<template>
  <div class="chart-wrap">
    <Echart :options="options" id="rightCenter1" height="100%" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart'
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        // console.log(newData.data, 'data娲楁钉娆℃暟鍒嗘瀽--------------')
        let grid = {
          left: '16%',
          right: '8%',
          top: '24%',
          bottom: '24%'
        };
        // console.error('-------newData',newData)
        const series = newData.seriesData.map((item, sid) => {
          return {
            name: item.name != null ? item.name : '-',
            type: 'bar',
            stack: 'total',
            barWidth: '34%',
            // label: {
            //   show: true,
            //   formatter: (params) => Math.round(params.value * 1000) / 10 + '%'
            // },
            data: newData.data[sid]
          };
        });
        this.options = {
          color: [
            "#4d9f87",
            "#006ce6",
            "#6870d0",
            "#37a2da",
            "#00d2f6",
            "#ffdb5c",
            "#8ec9f4",

            // "#8378ea",
            // "#37a2da",
            // "#6871d0",
            // "#4d9f88",
            // "#ffdb5c",
            // "#006de6",
            // "#00d2f5",
            // "#e7bcf3",
            
          ],
          tooltip: {
            show: 'true',
            trigger: 'axis',
            // triggerOn: 'click',
            textStyle: {
              fontSize: 10
            },
            axisPointer: {
              type: 'shadow',
              label: {
                show: true
              }
            }
          },
          legend: {
            icon: 'circle',
            selectedMode: false,
            top: '5%',
            left: 'center',
            width: '100%',
            itemWidth: 6,
            itemHeight: 6, //淇敼icon鍥惧舰澶у皬
            itemGap: 4,
            textStyle: {
              fontSize: 9
            },
          },
          grid,
          yAxis: {
            type: 'value',
            name: '',
            nameTextStyle: {
              fontSize: 12
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(161,164,165,0.5)"
              }
            },
            axisLine: {
              lineStyle: {
                color: "rgba(161,164,165,0.5)"
              }
            },
            axisLabel: {
              formatter: function (params) {
                // console.log(params, '-y杞?++++++++++++')
                // return params
                return params / 10;
              },
              textStyle: {
                fontSize: 10
              }
            }
          },
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: "rgba(161,164,165,0.5)"
              }
            },
            axisLabel: {
              rotate: 35, // text rotation
              formatter: function (params) {
                // console.log(params, '-y杞?++++++++++++')
                return params
              },
              textStyle: {
                fontSize: 10
              },
            },
            // data: ['0-20', '41-60', '81-100', '121-140']
            data: ['0-20', '21-40', '41-60', '61-80', '81-100', '101-120', '121-140']
          },
          series
        }
        if(this.$screenWidth >= 1520){
            this.options.grid = {
              left: '12%',
              right: '8%',
              top: '20%',
              bottom: '22%'
            }
            this.options.legend.textStyle.fontSize = 10
            this.options.tooltip.textStyle.fontSize = 12
            this.options.xAxis.nameTextStyle = { fontSize: 12 }
            this.options.xAxis.axisLabel.textStyle.fontSize = 12
            this.options.yAxis.nameTextStyle.fontSize = 12
            this.options.yAxis.axisLabel.textStyle.fontSize = 12
        }else if(this.$screenWidth >=1400 && this.$screenWidth < 1520){
          this.options.grid = {
              left: '12%',
              right: '8%',
              top: '22%',
              bottom: '22%'
            }
          this.options.legend.textStyle.fontSize = 8
          this.options.tooltip.textStyle.fontSize = 10
          this.options.xAxis.nameTextStyle = { fontSize: 10 }
          this.options.xAxis.axisLabel.textStyle.fontSize = 10
          this.options.yAxis.nameTextStyle.fontSize = 10
          this.options.yAxis.axisLabel.textStyle.fontSize = 10
        }


        // this.options = {
        //   radar: {
        //     indicator: newData.indicatorData,
        //     shape: "circle",
        //     splitNumber: 5,
        //     radius: ["0%", "65%"],
        //     name: {
        //       textStyle: {
        //         color: "rgb(238, 197, 102)"
        //       }
        //     },
        //     splitLine: {
        //       lineStyle: {
        //         color: [
        //           "rgba(238, 197, 102, 0.1)",
        //           "rgba(238, 197, 102, 0.2)",
        //           "rgba(238, 197, 102, 0.4)",
        //           "rgba(238, 197, 102, 0.6)",
        //           "rgba(238, 197, 102, 0.8)",
        //           "rgba(238, 197, 102, 1)"
        //         ].reverse()
        //       }
        //     },
        //     splitArea: {
        //       show: false
        //     },
        //     axisLine: {
        //       lineStyle: {
        //         color: "rgba(238, 197, 102, 0.5)"
        //       }
        //     }
        //   },
        //   series: [
        //     {
        //       name: "鍖椾含",
        //       type: "radar",
        //       lineStyle: lineStyle,
        //       data: newData.dataBJ,
        //       symbol: "none",
        //       itemStyle: {
        //         normal: {
        //           color: "#F9713C"
        //         }
        //       },
        //       areaStyle: {
        //         normal: {
        //           opacity: 0.1
        //         }
        //       }
        //     },
        //     {
        //       name: "涓婃捣",
        //       type: "radar",
        //       lineStyle: lineStyle,
        //       data: newData.dataSH,
        //       symbol: "none",
        //       itemStyle: {
        //         normal: {
        //           color: "#B3E4A1"
        //         }
        //       },
        //       areaStyle: {
        //         normal: {
        //           opacity: 0.05
        //         }
        //       }
        //     },
        //     {
        //       name: "骞垮窞",
        //       type: "radar",
        //       lineStyle: lineStyle,
        //       data: newData.dataGZ,
        //       symbol: "none",
        //       itemStyle: {
        //         normal: {
        //           color: "rgb(238, 197, 102)"
        //         }
        //       },
        //       areaStyle: {
        //         normal: {
        //           opacity: 0.05
        //         }
        //       }
        //     } //end
        //   ]
        // }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-wrap {
  width: 100%;
  height: 100%;
  transform: scale(0.95);
  transform-origin: center top;
}
</style>

